/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../custom-hooks';
import { evaluateSetValuePropForControls } from '../actions/runtime.actions';
import { FormContext } from '../context';
import { getEntityData } from '../selectors/common.selectors';

/**
 * Handles setValue property for each control in fromModel.
 * Reevaluates this property every time entityData changes.
 * Creates indexes for controls based on current entityData.
 */
const ValueOverrideController = () => {
  const dispatch = useDispatch();
  const entityData = useFormSelector(getEntityData);
  const formKey = useContext(FormContext);

  useEffect(() => {
    dispatch(evaluateSetValuePropForControls(formKey));
  }, [entityData]);

  return <div style={{ display: 'none' }} />;
};

export default ValueOverrideController;
